function MainPage(): JSX.Element {
  return (
    <>
      <h1>Вы пришли на страницу оплаты заказов.</h1>
    </>
  );
}

export default MainPage;